

import React, {Component} from 'react';
import {i18nInterface} from '../../utilities/i18n_common';
import AButton from '../../common/buttons/components/AButton';
import MDisplayFormError from '../../common/inputs/containers/MDisplayFormError';
import PropTypes from 'prop-types';

class OSaveDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      locked: false,
      email: props.email,
    };
  }

  /**
     * Change of email input
     * @param {object} event
     */
  onChangeEmail(event) {
    this.setState({
      email: event.target.value,
    });
  }


  render() {
    const {
      email,
      locked,
    } = this.state;
    const {
      formModel,
      onPressButtonSave,
      errors,
    } = this.props;
    return (
      <div>
        <p className="a-paragraph">
          {i18nInterface('saveProgress.solution')}
        </p>
        <div className="o-save-dialog__input">
          <input type="text"
            placeholder={i18nInterface('saveProgress.placeholder')}
            onChange={(e) => this.onChangeEmail(e)}
            value={email}
          />
        </div>
        <div className="o-save-dialog__button">
          {!locked ? (<AButton
            onPress={async (e) => {
              this.setState({
                locked: true,
              });
              await onPressButtonSave(e, email);
              this.setState({
                locked: false,
              });
            }}
            label={i18nInterface('saveProgress.buttonLabel')}
            title={i18nInterface('saveProgress.buttonLabel')}
            look={'filled'}
            size={'normal'}
            color={'green'}
          />) : (<span className="a-spinner a-spinner-square"></span>)}
        </div>
        <MDisplayFormError
          formModel={formModel}
          showErrors={errors ? true : false}
          message={i18nInterface(errors)}
        />
      </div>
    );
  }
}

OSaveDialog.propTypes = {
  /**
     * model of the current form
     */
  formModel: PropTypes.string.isRequired,

  /**
     * initial Email
     */
  email: PropTypes.string,

  onPressButtonSave: PropTypes.func,
  /**
     * error message
     */
  errors: PropTypes.string,
};

export default OSaveDialog;
